module.exports = __webpack_public_path__ + "img/surepay.bfdb8ecc.svg";